module.exports = __webpack_public_path__ + "img/Vijae Alquisola.cfb168af.jpg";